import { useMutation } from '@tanstack/react-query';
import { MerchantApiCredentialsService } from 'services/openapi';

// Deactivate a credential (ACTIVE → INACTIVE)
export const useRevokeMerchantCredentialMutation = () => {
  const { isLoading, error, data, isError, isSuccess, mutate, mutateAsync } =
    useMutation<any, Error, { id: string }>({
      mutationFn: ({ id }) =>
        MerchantApiCredentialsService.merchantApiControllerUpdateClientStatus(
          id,
          { status: 'INACTIVE' },
        ),
    });

  return { isLoading, isSuccess, error, data, isError, mutate, mutateAsync };
};

// Reactivate a credential (INACTIVE → ACTIVE)
export const useActivateMerchantCredentialMutation = () => {
  const { isLoading, error, data, isError, isSuccess, mutate, mutateAsync } =
    useMutation<any, Error, { id: string }>({
      mutationFn: ({ id }) =>
        MerchantApiCredentialsService.merchantApiControllerUpdateClientStatus(
          id,
          { status: 'ACTIVE' },
        ),
    });

  return { isLoading, isSuccess, error, data, isError, mutate, mutateAsync };
};

// Hard delete a credential
export const useDeleteMerchantCredentialMutation = () => {
  const { isLoading, error, data, isError, isSuccess, mutate, mutateAsync } =
    useMutation<any, Error, { id: string }>({
      mutationFn: ({ id }) =>
        MerchantApiCredentialsService.merchantApiControllerDeleteClient(id),
    });

  return { isLoading, isSuccess, error, data, isError, mutate, mutateAsync };
};
